'use strict';

const MODAL_SELECTOR = '.performance-modal';
const DESKTOP_BREAKPOINT = 1152; // Matches the isDesktopView() check in calendar.js (max-width: 1151px)

export function init() {
    document.addEventListener('click', event => {
        // Only enable click-outside-to-close on desktop
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
            return;
        }

        const modal = event.target.closest(MODAL_SELECTOR);

        if (!modal) {
            return;
        }

        // Check if the click was directly on the modal backdrop (not on the inner content)
        if (event.target === modal) {
            // Find and trigger the close button for this modal
            const closeButton = modal.querySelector('.performance-toggle');
            if (closeButton) {
                closeButton.click();
            }
        }
    }, false);
}

export default { init }
